import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './assets/favicon.ico';

ReactDOM.render(<App />, document.getElementById('root'));
